export default __webpack_public_path__ + "static/media/bg-aspet2024.8c510020.png";